import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M9 4.507v15m6-15v15m-10.875 0h15.75c.621 0 1.125-.504 1.125-1.125V5.632c0-.621-.504-1.125-1.125-1.125H4.125C3.504 4.507 3 5.01 3 5.632v12.75c0 .621.504 1.125 1.125 1.125"
    }, null, -1)
  ])))
}
export default { render: render }